<template>
  <ion-page id="genai-position">

    <AlertReplacement :alertInfo="alertInfo" :trigger="alertTrigger"
            @alert-result="alertResult"></AlertReplacement>

    <ion-content>

      <div v-show="showState == SHOW_BUILD_BOARD || showState == SHOW_ROOM || showState == SHOW_ONLINE_GAME_LIST">
        <div id="the_board" :style="styleBoard">
            <CMChessboard :fen="fen" :validMoves="availableMoves"
                      :sideCarPiece="sideCarPiece"
                      :orientation="orientation" 
                      :setSquareColor="mainSquareColorArray"
                      :flagBadMove="!isViewerMode"
                      :animateOnePly="animateFen" 
                      :hint="hintFen"
                      :arrows="arrowPairs"
                      :sparePieces="sparePieces"
                      :boardSize="boardSize" 
                      :doEmitEveryMove="doEmitEveryMove"
                      :canPromoteToAnyPiece=true
                      @board-move="boardMove" 
                      @move-made="moveMade"
                      />
        </div>
        <!-- move indicators -->
        <div v-show="(!whiteToMove && orientation=='white') || (whiteToMove && orientation=='black')" id="top_move" :style="styleTopMove" :key="!whiteToMove">
        </div>
        <div v-show="(whiteToMove && orientation=='white') || (!whiteToMove && orientation=='black')" id="bottom_move" :style="styleBottomMove" :key="whiteToMove">
        </div>
      </div>

      <!-- BOARD POSITION BUILDER -->
      <div v-show="showState == SHOW_BUILD_BOARD">
        <div :style="styleClipContainer" >
          <div :style="styleClipBoard">
            <CMChessboard :fen="selectorFen" 
                    :isPiecePicker=true
                    orientation="white" 
                    :flagBadMove=true
                    :setSquareColor="squareColorArray"
                    :boardSize="boardSize" @board-move="boardSelector" />
          </div>
        </div>
      </div>

      <!-- MAIN SCREEN -->
      <div v-show="showState == SHOW_ROOM">

        <div  id="the_infowindow" 
                    :style="styleInfoWindow" 
                    :class="{ 'text-dark' : isDark, 
                              'text-light' : !isDark, 
                              'info-window-dark' : isDark,
                              'info-window-light' : !isDark,
                              'info-still-working-dark' : isDark && streamIsWorking,
                               'info-still-working-light' : !isDark && streamIsWorking,
                              }">
          <div v-show="showInfoState == SHOW_INITIAL_INFO">
            <b>*** Welcome ***</b>
            <p>You can 'Paste In A Game (PGN)or <br>Board Position (FEN) or <br>setup something specific'</p>
            <b>*** Paste in Game via Options &amp; Setup Board ***</b>
            <p>Or Just start making moves here</p>
          </div>
          <div v-show="showInfoState == SHOW_SCORING_GAME">
            <b>*** Scoring The Game ***</b>
            <p>
              <i>{{ scoringSecondsLeft }}</i>
            </p>
          </div>
          <div v-show="showInfoState == SHOW_INTERESTING_MOVES">
            <b>*** Moves to Review ***</b>
            <div v-show="interestingMoveDisplayArray.length == 0">
              <i>{{ scoringSecondsLeft }}</i>
            </div>
              <div v-show="interestingMoveDisplayArray.length != 0">
            </div>
            <div v-for="item in interestingMoveDisplayArray" v-bind:key="item.id" @click="interestingMoveClick(item)"
                          :class="{ 'item-selected' : item.selected }"> 
              <span class="interesting-move">
                {{ item.displaySan }}
              </span>
              <span>
                {{ capitalize(item.interestingMoveType) }}! {{ item.colorName }} score:({{ item.yourScoreDisplay }}). Best {{ item.bestMove }} ({{ item.bestScoreDisplay }})
              </span>
            </div>
          </div>
          <div v-show="showInfoState == SHOW_MOVE_CHOICES">
            <b>*** {{ moveChoiceColor }}'s move choices after {{ moveChoiceNumber }}{{ (moveChoiceColor == "Black" ? "." : "...") }}{{ moveChoiceSan }} ***</b>
            <div v-show="moveChoiceDisplayArray.length == 0">
              <i>{{ scoringSecondsLeft }}</i>
            </div>
              <div v-show="moveChoiceDisplayArray.length != 0">
            </div>
            <div v-for="item in moveChoiceDisplayArray" v-bind:key="item.index" @click="moveChoiceClick(item)"
                       :class="{ 'item-selected' : item.selected }"> 
              <span class="interesting-move">
                {{ item.bestMove }}
              </span>
              <span>
                ({{ item.scoreDisplay }}) {{ item.bestMoves }}
              </span>
            </div>
          </div>
          <div v-show="showInfoState == SHOW_GAME_ANALYSIS">
            <div v-html="markdownHTML" :class="{
                          'info-still-working' : streamIsWorking, 
                }"
            @click="handleGameMarkdownClick"></div>
          </div>
          <div v-show="showInfoState == SHOW_MOVE_ANALYSIS">
            <div v-html="markdownHTML" @click="handleMoveMarkdownClick"></div>
          </div>
          <!-- add 0px height invisible element. have program scroll down it to -->
          <!-- <div id="bottom-element" class="invisible-bottom-element"></div> -->
        </div>

        <div id="the_engine_score" :style="styleEngineScores" 
                        :class="{ 'info-me-dark' : isDark, 'info-me-light' : !isDark}">
          <div v-html="scoreDisplayString"></div>
        </div>

        <div id="the_movehistory" :style="styleMoveHistory" 
                        :class="{ 'text-dark' : isDark, 'text-light' : !isDark }">
          <div v-show="showMoves">
            <RepTreeNewView 
                :treeDisplay="treeDisplay"
                :score="score"
                :treeTrigger="treeTrigger" 
                @move-click="repTreeMoveClick"
                @branch-click="repTreeBranchClick"/>
          </div>
        </div>

      </div>

      <div v-show="showState == SHOW_ONLINE_GAME_LIST">
        <div :style="styleOnLineGames"
                        :class="{ 'text-dark' : isDark, 'text-light' : !isDark }"
                        class="different-background"
                        >
          SHOW ONLINE LIST
        </div>
      </div>

      <ActionSheet heading="Options" :items="actionSheetButtons" 
                  :trigger="actionSheetTrigger"
                  @action-sheet-result="actionSheetResult">
      </ActionSheet>
    </ion-content>
    <Toolbar :elements="toolbarElements" :trigger="toolbarTrigger"        
                        @toolbar-click="toolbarClick"/>
  </ion-page>
</template>

<script setup>

// https://github.com/shanet/WebRTC-Example

// dude works with brad traversy
// https://www.youtube.com/watch?v=QsH8FL0952k
// https://github.com/divanov11/Peerinfo

// multiple peer code
// https://github.com/webrtc/samples/blob/gh-pages/src/content/peerconnection/multiple/js/main.js


import { IonCheckbox, IonIcon, IonGrid,IonRow,IonCol,IonButton,IonButtons,IonItem,IonInput,IonPage, IonContent, modalController } from '@ionic/vue';

import { arrowUndoOutline,brushOutline, swapVerticalOutline, arrowBackOutline,arrowForwardOutline,arrowUpOutline, caretBackOutline,caretForwardOutline,micOutline, micOffOutline, sendOutline, timer, move} from 'ionicons/icons';

import { t } from '@/composables/translateText.js'

import { Chess, validateFen } from '@/ts/chess.ts'
import { buildPieceLocationStrings, getPieceSetName , columnToNumber, buildAvailableMoves,
  listOfSquaresWithNewPieces, buildCastleString } from '@/composables/blindfoldSupport.js'

import { ref, watch , onMounted, onBeforeUnmount, onUnmounted, createElementBlock } from 'vue';
import ModalLearnPreferences from '@/components/ModalLearnPreferences.vue'
import ModalErrorMessage from '@/components/ModalErrorMessage.vue'
import CMChessboard from '@/components/CMChessboard.vue'
import AlertReplacement from '@/components/AlertReplacement.vue'
import ActionSheet from '@/components/ActionSheet.vue'
import ModalGenericMultiList from '@/components/ModalGenericMultiList.vue'

import Toolbar from '@/components/Toolbar.vue';
import MoveHistory from '@/components/MoveHistory.vue'
import RepTreeNewView from '@/components/RepTreeNewView.vue';

import { findToolbarElement, setToolbarElementDisabledFlag, 
                  setToolbarElementLabel, setAllToolbarElementsDisabled, restoreAllToolbarElementsDisabled} 
              from '@/composables/toolbarSupport.js'

import { getWebSiteURL, useGetData , getLichessData, generateErrorAlertText } from '@/composables/getData.js'

import { useConnectionStore } from '@/stores/connectionStore';
import { useWindowSizeStore } from '@/stores/windowSizeStore';
import { doStartupCheck } from '@/composables/startupCheck.js'
import { availableWidthHeight, calculateChessBoardRect, isScreenPortraitOrientation } 
            from '@/composables/screenSize'
import MarkdownIt from "markdown-it";

const md = new MarkdownIt({
  html: true,
  linkify: true,
  typographer: true
});

var markdownText = ""
var gameJsonString = ""
var moveJsonString = ""

//const markdownText = "# Hello [1.e4](#move20) \n\nThis is *italic* text. [3.a8=Q](#move40)"
//const markdownText = '*   **Move 1-2:** The game starts with 1. e4. Black replies with **<a href=\"#2b\">2... d5</a>**, a solid choice that leads to a Scandinavian Defense structure. White move **<a href=\"#2w\">2. c3?</a>** is labeled an \"error\". This is a passive choice. The natural and best continuation was **2. exd5**, forcing Black to recapture and allowing White to develop quickly with Nf3. After 2. c3, Black can simply capture on e4, and White has no immediate way to challenge the center. The score swings from +0.75 (White advantage) to -0.93 (Black advantage).'
const markdownHTML = ref(md.render(markdownText))
//console.log("**** HTML -> ",markdownHTML.value)
  
const MOVEHISTORY_FONTSIZE = 16
const MOVEHISTORY_HEIGHT =  MOVEHISTORY_FONTSIZE * 1.2 + 4

const WHO_MOVE_HEIGHT = 50
const WHO_MOVE_WIDTH = 16

var chess = new Chess()
var gameHash = ""
var openingName = ""
// move hash is just the FEN
var moveHash = ""

// if in viewer mode, then can't make moves on board. do that by disabling available moves
var isViewerMode = true
var streamIsWorking = ref(false)
var streamLineBuffer = ""
var streamingGame = true

const scoringSecondsLeft = ref("Scoring....")

const connectionStore = useConnectionStore()

const urlAction = connectionStore.getUrlIsAI
const urlGame = (urlAction) ?  localStorage.getItem("url_game") : ""
const urlHash = (urlGame != "") ? urlGame.slice(-16) : ""
//console.log("URLACTION ",urlAction,urlGame,urlHash)

const isDark = ref(connectionStore.getDarkmode != "light")

const menuTrigger = ref(0)

const TOOLBAR_DONE = 0
const toolbarTrigger = ref(0)

const windowSizeStore = useWindowSizeStore()
const windowSizeRef = ref({ width : windowSizeStore.getWindowSize['width'],
                      height : windowSizeStore.getWindowSize['height'] })
const boardSize = ref(100)

const sparePieces = ref("build")

const infoMessage = ref("")

var remoteIndex = 0

// this will uniquely ID the connection for Peer-to-Peer stuff
const myUUID = connectionStore.getSessionUUID
//console.log("MY UUID",myUUID)

var inRecents = false

var treeDisplay = ref([])
const treeTrigger = ref(0)
var score = ref("0.00")

const interestingMoveDisplayArray = ref([])
const moveChoiceDisplayArray = ref([])
const moveChoiceColor = ref("White")
const moveChoiceNumber = ref("1")
const moveChoiceSan = ref("")

// force move choice calculation even if wanting move analysis
var doMoveAnalysis = false

const INITIAL_FEN = "rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1"
const EMPTY_FEN = "8/8/8/8/8/8/8/8 w - - 0 1"

const SELECTOR_FEN_LANDSCAPE = "rR6/nN6/bB6/qQ6/kK6/pP6/8/8 w - - 0 1"
const SELECTOR_FEN_PORTRAIT = "rnbqkp2/RNBQKP2/8/8/8/8/8/8 w - - 0 1"

var isPortrait = true

const selectorFen = ref(SELECTOR_FEN_PORTRAIT)
const fen = ref(INITIAL_FEN)

var blankAppendTrigger = " "
var orientation = ref("white")
const availableMoves = ref([])
const availableMovesForBuilder = [ { from : "any"}]
var saveAvailableMoves = []

const hintFen = ref([])
const animateFen = ref([])
const squareColorArray = ref([])
const mainSquareColorArray = ref([])
var arrowPairs = ref([])

var isPGN = false
var isPGNDisplayed = false
var pgnSans = ""
var pgnIndex = 0

var currentSelectedMoveIndex = 0

const doEmitEveryMove = ref(true)

const sideCarPiece = ref("")
var whiteToMove = ref(true)
var positionIsValid = true

var completeFen = INITIAL_FEN

// engine scores
//    the map will have a key of "fen" and the stored engine stores as the value
var engineScoreMap = new Map()
//    the chess object to determine the SAN
var chessForEngineScore = null
const scoreDisplayString = ref("SCORING")

const alertInfo = ref({})
const alertTrigger = ref(0)

const SHOW_ROOM = 1
const SHOW_BUILD_BOARD = 2
const SHOW_ONLINE_GAME_LIST = 3

const showMoves = ref(true)

var calcScoreSeconds = 0
var timerCanStop = false

const SHOW_INITIAL_INFO = 0
const SHOW_INTERESTING_MOVES = 1
const SHOW_MOVE_CHOICES = 2
const SHOW_GAME_ANALYSIS = 3
const SHOW_MOVE_ANALYSIS = 4
const SHOW_SCORING_GAME = 5

const showState = ref(SHOW_ROOM)
const showInfoState = ref(SHOW_INITIAL_INFO)

const TOOLBAR_BUILD_FEN = 30
const TOOLBAR_BUILD_WHO_MOVE = 31
const TOOLBAR_BUILD_PGN = 32
const TOOLBAR_BUILD_DONE = 33
const TOOLBAR_BUILD_DONE_FROM_PGN = 39

const toolbarBuildBoardElements = [
{ index : TOOLBAR_BUILD_FEN, label : "Board Source" , disabled : false, collapse:false},
{ index : TOOLBAR_BUILD_WHO_MOVE, label : "White To Move" , disabled : false, collapse:false},
{ index : TOOLBAR_BUILD_PGN, label : "Paste Game" , disabled : false, collapse:false},
{ index : TOOLBAR_BUILD_DONE, label : "Done" , disabled : false, collapse:false},
]

const TOOLBAR_MAIN_BACK = 0
const TOOLBAR_MAIN_FORWARD = 1
const TOOLBAR_MAIN_AI = 2
const TOOLBAR_MAIN_BACK_TO_GAME = 300
const TOOLBAR_PASTE_GAME = 3
const TOOLBAR_MAIN_COACH = 4
const TOOLBAR_MAIN_FLIP = 5

// const toolbarMainElements = [
// { index : TOOLBAR_MAIN_BACK, label : "" , icon:arrowBackOutline,disabled : false, collapse:false},
// { index : TOOLBAR_MAIN_FORWARD, label : "" , icon:arrowForwardOutline, disabled : false, collapse:false},
// { index : TOOLBAR_MAIN_AI, label : "A.I." , hasAction : true},
// { index : TOOLBAR_MAIN_BACK_TO_GAME, label : "Game" , icon:arrowUpOutline, disabled : true, collapse:false},
// { index : TOOLBAR_MAIN_COACH, label : "Options" , hasAction : true}
// ]


const toolbarMainUrlElements = [
{ index : TOOLBAR_MAIN_BACK, label : "" , icon:arrowBackOutline,disabled : false, collapse:false},
{ index : TOOLBAR_MAIN_FORWARD, label : "" , icon:arrowForwardOutline, disabled : false, collapse:false},
{ index : TOOLBAR_MAIN_AI, label : "A.I." , hasAction : true},
{ index : TOOLBAR_PASTE_GAME, label : "Paste Game" , hasAction : false},
{ index : TOOLBAR_MAIN_FLIP, label : "Flip" , hasAction : false}
]

const toolbarElements = ref([])

const actionSheetTrigger = ref(0)
const ACTION_COACH_OPTION_INDEX = 10
const ACTION_COACH_OPTION_COPY = 11
const ACTION_COACH_OPTION_BUILD_BOARD = 12
const ACTION_COACH_OPTION_FLIP_BOARD = 13

var coachActionSheetButtons = [
    { text: "Copy to Clipboard", data: { index: ACTION_COACH_OPTION_COPY } },
    { text: "Set Up Board", data: { index: ACTION_COACH_OPTION_BUILD_BOARD } },
    { text: "Flip Board", data: { index: ACTION_COACH_OPTION_FLIP_BOARD } },
    { text: 'Cancel', role: 'cancel',data: { index : -1}}
  ]

const ACTION_AI_OPTION_INDEX = 20
const ACTION_AI_OPTION_INTERESTING_MOVE = 21
const ACTION_AI_OPTION_MOVE_CHOICES = 22
const ACTION_AI_OPTION_GAME_OVERVIEW = 23
const ACTION_AI_OPTION_GAME_ANALYSIS = 24
const ACTION_AI_OPTION_MOVE_ANALYSIS = 25

var aiActionSheetButtons = [
    { text: "Moves to Review", data: { index: ACTION_AI_OPTION_INTERESTING_MOVE } },
    { text: "Move Choices by Engine", data: { index: ACTION_AI_OPTION_MOVE_CHOICES } },
    { text: "Short Game Overview by AI", data: { index: ACTION_AI_OPTION_GAME_OVERVIEW } },
    { text: "Complete Game Analysis by AI", data: { index: ACTION_AI_OPTION_GAME_ANALYSIS } },
    { text: "Move Choice Analysis by AI", data: { index: ACTION_AI_OPTION_MOVE_ANALYSIS } },
    { text: 'Cancel', role: 'cancel',data: { index : -1}}
  ]

const actionSheetButtons = ref([])

const styleOneFrame = ref({
   position : "absolute",
   "overflow-y" : "scroll",
   top : "0px",
   left : "100px",
   width: "100px",
   height : "100px"
 })

 const styleBoard = ref({
  position : "absolute",
  top : "0px",
  left : "100px",
  width: "100px",
  height : "100px",
  cursor: "auto"
})

const styleTopMove = ref({
  position : "absolute",
  top : "0px",
  left : "100px",
  width: "100px",
  height : "100px",
  "background-color" : "steelblue"
})

const styleBottomMove = ref({
  position : "absolute",
  top : "0px",
  left : "100px",
  width: "100px",
  height : "100px",
  "background-color" : "steelblue"
})


const styleClipContainer = ref({
  position : "absolute",
  top : "0px",
  left : "100px",
  width: "100px",
  height : "100px",
  overflow : "hidden"
})

const styleClipBoard = ref({
  position : "absolute",
  top : "0px",
  left : "100px",
  width: "100px",
  height : "100px"
})

const styleInfoWindow = ref({
  position : "absolute",
  "overflow-y" : "scroll",
  top : "0px",
  left : "100px",
  width: "100px",
  height : "100px",
  "margin-bottom" : "0px",
  "margin-top" : "0px",
  "cursor": "pointer"
})

const styleMoveHistory = ref({
  position : "absolute",
  "overflow-y" : "scroll",
  top : "0px",
  left : "100px",
  width: "100px",
  height : "100px",
  "font-size" : MOVEHISTORY_FONTSIZE + "px",
  "text-align" : "left",
  "line-height" : "1.2em",
  // "color" : "white"
  "margin-top" : "0px",
  "cursor": "pointer"
})

const styleEngineScores = ref({
  position : "absolute",
  "overflow-y" : "scroll",
  top : "100px",
  left : "100px",
  width: "100px",
  height : "100px",
  "font-size" : MOVEHISTORY_FONTSIZE + "px",
  "text-align" : "left",
  "line-height" : "1.2em",
  "padding-left" : "3px",
  "padding-top" : "2px",
  "cursor": "auto"

})

const styleOnLineGames = ref({
  position : "absolute",
  "overflow-y" : "scroll",
  top : "0px",
  left : "100px",
  width: "100px",
  height : "100px",
  "font-size" : MOVEHISTORY_FONTSIZE + "px",
  "text-align" : "left",
  "line-height" : "1.2em",
  // "color" : "white"
  "margin-top" : "0px",
  "cursor": "pointer"
})

doStartupCheck(false,afterStartupCallbackRoutine)

function incrementAppendTrigger() {
  if (blankAppendTrigger.length > 64)
    blankAppendTrigger = ""
  blankAppendTrigger += " "
}

function capitalize(str) {
  if (str.length == 0)
    return ("")
  return(str.charAt(0).toUpperCase() + str.slice(1))
}

const keyState = {
  ArrowUp: false,
  ArrowDown: false,
  ArrowLeft: false,
  ArrowRight: false
}
const handleKeyDown = (event) => {
  if (event.key in keyState) {
    keyState[event.key] = true;
    // Optional: prevent page scrolling
    if (['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'].includes(event.key)) {
      event.preventDefault();
    }
    //console.log("keystate",keyState)
    if (keyState.ArrowLeft)
      shiftSelectedMove("back")
    else
    if (keyState.ArrowRight)
      shiftSelectedMove("forward")
    else
    if (keyState.ArrowUp) {
      var foundSelected = false
      //console.log("arrow up",showInfoState.value)
      if (showInfoState.value == SHOW_MOVE_CHOICES) {
        for (var i=0; i < moveChoiceDisplayArray.value.length; i++) {
          //console.log("in keyup",i,moveChoiceDisplayArray.value[i])
          if (moveChoiceDisplayArray.value[i].selected) {
            foundSelected = true
            if (i > 0)
              moveChoiceClick(moveChoiceDisplayArray.value[i-1])
            break
          }
        }
        // if nothing selected, pick the top one
        if (!foundSelected && moveChoiceDisplayArray.value.length > 0)
          moveChoiceClick(moveChoiceDisplayArray.value[0])
      }
      else
      if (showInfoState.value == SHOW_INTERESTING_MOVES) {
        for (var i=0; i < interestingMoveDisplayArray.value.length; i++) {
          //console.log("in keyup",i,interestingMoveDisplayArray.value[i])
          if (interestingMoveDisplayArray.value[i].selected) {
            foundSelected = true
            if (i > 0)
              interestingMoveClick(interestingMoveDisplayArray.value[i-1])
            break
          }
        }
        // if nothing selected, pick the top one
        if (!foundSelected && interestingMoveDisplayArray.value.length > 0)
          interestingMoveClick(interestingMoveDisplayArray.value[0])
      }
    }
    else
    if (keyState.ArrowDown) {
      var foundSelected = false
      if (showInfoState.value == SHOW_MOVE_CHOICES) {
        for (var i=0; i < moveChoiceDisplayArray.value.length; i++) {
          if (moveChoiceDisplayArray.value[i].selected) {
            foundSelected = true
            if (i < moveChoiceDisplayArray.value.length-1)
              moveChoiceClick(moveChoiceDisplayArray.value[i+1])
            break
          }
        }
        // if nothing selected, pick the top one
        if (!foundSelected && moveChoiceDisplayArray.value.length > 0)
          moveChoiceClick(moveChoiceDisplayArray.value[0])
      }
      else
      if (showInfoState.value == SHOW_INTERESTING_MOVES) {
        for (var i=0; i < interestingMoveDisplayArray.value.length; i++) {
          if (interestingMoveDisplayArray.value[i].selected) {
            foundSelected = true
            if (i < interestingMoveDisplayArray.value.length-1)
              interestingMoveClick(interestingMoveDisplayArray.value[i+1])
            break
          }
        }
        // if nothing selected, pick the top one
        if (!foundSelected && moveChoiceDisplayArray.value.length > 0)
          interestingMoveClick(interestingMoveDisplayArray.value[0])
      }
    }
  }
};

const handleKeyUp = (event) => {
  if (event.key in keyState) {
    keyState[event.key] = false;
  }
};

 onMounted(() => {

  window.addEventListener('keydown', handleKeyDown);
  window.addEventListener('keyup', handleKeyUp);

  fen.value = INITIAL_FEN
  loadRepTreeFromChessHistory(INITIAL_FEN,[],0,true,false)

  selectorFen.value = SELECTOR_FEN_PORTRAIT + blankAppendTrigger
})

onBeforeUnmount(() => {
    //console.log("in onBeforeUnmount")
  })

onUnmounted(() => {
  window.removeEventListener('keydown', handleKeyDown);
  window.removeEventListener('keyup', handleKeyUp);
})

watch(() => windowSizeStore.getWindowSize, () => {
    //console.log('*********** window size changes detected')
    windowSizeRef.value = { width : windowSizeStore.getWindowSize['width'],
                      height : windowSizeStore.getWindowSize['height'] }
    //console.log("*** logoff new window size",windowSizeRef.value)
    menuTrigger.value++
    updateWidthHeights()
  })

  function handleGameMarkdownClick(event) {
    //console.log("markdown click",event)
    const link = event.target.closest("a");
    if (!link) return;

    const href = link.getAttribute("href");

    // Prevent normal navigation
    event.preventDefault();

    // Do whatever you want in Vue
    //console.log("Clicked markdown link:", href,href.length);

    if (href.length < 3)
      return;

    if (href[0] != "#")
      return
    const moveNumber = parseInt(href.substring(2))
    var plyNumber = (moveNumber-1) * 2 + 1
    if (href[1] == "b")
      plyNumber++
    repTreeMoveClick(treeDisplay.value[0].moves[plyNumber])
  }

  function handleMoveMarkdownClick(event) {
    //console.log("markdown click",event)
    const link = event.target.closest("a");
    if (!link) return;

    const href = link.getAttribute("href");

    // Prevent normal navigation
    event.preventDefault();

    // Do whatever you want in Vue

    // get rid of the #
    const hrefMove = href.substring(1)
    //console.log("Clicked move markdown link:", href,hrefMove);

    // find the link text in the "strippedSan"

    for (var i=0; i < moveChoiceDisplayArray.value.length; i++) {
      if (hrefMove == moveChoiceDisplayArray.value[i].strippedSan) {
        moveChoiceClick(moveChoiceDisplayArray.value[i])
        break
      }
    }
  }

  const openErrorModal = async (programName,errorMessage) => {
    const modal = await modalController.create({
      component: ModalErrorMessage,
      componentProps: {
        type : "commError",
        program : programName ,
        errorMessage : errorMessage
      }
    });

    modal.present();

    const { data, role } = await modal.onWillDismiss();
  };

  // ADD Modal
  const learnPreferencesModal = async (action) => {
    const modal = await modalController.create({
      component: ModalLearnPreferences,
      componentProps: {
        action : "add",
        min : 800,
        max : 1200,
        color : "white",
        name : "blah",
        editPercentage : 1
      }
    });

    modal.present();

    const { data, role } = await modal.onWillDismiss();

    if (role === 'confirm') {
    }
      
  };

function afterStartupCallbackRoutine(stuffChanged,errorProgram,errorEntry) {
  if (errorProgram != null)
      openErrorModal(errorProgram,errorEntry)
  menuTrigger.value++
  updateWidthHeights()

  //toolbarElements.value = JSON.parse(JSON.stringify((urlAction) ? toolbarMainUrlElements : toolbarMainElements))
  toolbarElements.value = JSON.parse(JSON.stringify(toolbarMainUrlElements))
  toolbarTrigger.value++

  if (urlAction)
    loadGame(urlHash)
}

function ordinal(n) {
    const suffixes = ['th', 'st', 'nd', 'rd'];
    const v = n % 100;
    return n + (suffixes[(v - 20) % 10] ?? suffixes[v] ?? suffixes[0]);
}

function updateWidthHeights() {

  const availableSpace = availableWidthHeight()
  const oneframePositionTop = availableSpace.topIndent
  const oneframePositionLeft = availableSpace.leftRightIndent + availableSpace.leftIndent
  const oneframeHeight = availableSpace.height - oneframePositionTop
  const oneframeWidth = availableSpace.width - availableSpace.leftRightIndent * 2

  // used for the connect screen
  styleOneFrame.value.height = oneframeHeight + "px"
  styleOneFrame.value.width = oneframeWidth + "px"
  styleOneFrame.value.top = oneframePositionTop + "px"
  styleOneFrame.value.left = oneframePositionLeft + "px"

  // used for the board & info
  isPortrait = isScreenPortraitOrientation(availableSpace)
  const boundaries = (isPortrait) ? calculatePortraitWidthHeights(availableSpace) :
                                    calculateLandscapeWidthHeights(availableSpace)
  updateStyleObjects(boundaries)
  incrementAppendTrigger()
  selectorFen.value = ((isPortrait) ? SELECTOR_FEN_PORTRAIT : SELECTOR_FEN_LANDSCAPE) + blankAppendTrigger
}

function updateStyleObjects(boundaries) {
  boardSize.value = boundaries['board'].height

  styleBoard.value.height = boundaries['board'].height + "px"
  styleBoard.value.width = boundaries['board'].width + "px"
  styleBoard.value.top = boundaries['board'].top + "px"
  styleBoard.value.left = boundaries['board'].left + "px"

  styleInfoWindow.value.height = boundaries['info'].height + "px"
  styleInfoWindow.value.width = boundaries['info'].width + "px"
  styleInfoWindow.value.top = boundaries['info'].top + "px"
  styleInfoWindow.value.left = boundaries['info'].left + "px"

  styleMoveHistory.value.height = boundaries['history'].height + "px"
  styleMoveHistory.value.width = boundaries['history'].width + "px"
  styleMoveHistory.value.top = boundaries['history'].top + "px"
  styleMoveHistory.value.left = boundaries['history'].left + "px"

  styleEngineScores.value.height = boundaries['score'].height + "px"
  styleEngineScores.value.width = boundaries['score'].width + "px"
  styleEngineScores.value.top = boundaries['score'].top + "px"
  styleEngineScores.value.left = boundaries['score'].left + "px"

  styleClipContainer.value.height = boundaries['clipContainer'].height + "px"
  styleClipContainer.value.width = boundaries['clipContainer'].width + "px"
  styleClipContainer.value.top = boundaries['clipContainer'].top + "px"
  styleClipContainer.value.left = boundaries['clipContainer'].left + "px"

  styleClipBoard.value.height = boundaries['clipBoard'].height + "px"
  styleClipBoard.value.width = boundaries['clipBoard'].width + "px"
  styleClipBoard.value.top = boundaries['clipBoard'].top + "px"
  styleClipBoard.value.left = boundaries['clipBoard'].left + "px"

  styleTopMove.value.height = boundaries['topMove'].height + "px"
  styleTopMove.value.width = boundaries['topMove'].width + "px"
  styleTopMove.value.top = boundaries['topMove'].top + "px"
  styleTopMove.value.left = boundaries['topMove'].left + "px"

  styleBottomMove.value.height = boundaries['bottomMove'].height + "px"
  styleBottomMove.value.width = boundaries['bottomMove'].width + "px"
  styleBottomMove.value.top = boundaries['bottomMove'].top + "px"
  styleBottomMove.value.left = boundaries['bottomMove'].left + "px"

  styleOnLineGames.value.height = boundaries['onlineGames'].height + "px"
  styleOnLineGames.value.width = boundaries['onlineGames'].width + "px"
  styleOnLineGames.value.top = boundaries['onlineGames'].top + "px"
  styleOnLineGames.value.left = boundaries['onlineGames'].left + "px"
}

function calculatePortraitWidthHeights(availableSpace) {

  const hardcodedVerticalSpace = 250

  const availableSpaceForBoard = { width : availableSpace.width - WHO_MOVE_WIDTH,
                height : availableSpace.height / 3,
                isPortrait : true }

  const boardDimensions = calculateChessBoardRect(availableSpaceForBoard,1.0)

  const boardHeight = boardDimensions.height
  const boardWidth = boardDimensions.width
  const boardPositionTop = boardDimensions.y
  const boardPositionLeft = boardDimensions.x + availableSpace.leftRightIndent

  const topMoveHeight = WHO_MOVE_HEIGHT
  const topMoveWidth = WHO_MOVE_WIDTH
  const topMovePositionTop = boardPositionTop
  const topMovePositionLeft = boardPositionLeft + boardWidth

   // grab the vertical for engine score
  const engineScoreTop = boardPositionTop + boardHeight
  const engineScoreLeft = availableSpace.leftRightIndent
  const engineScoreWidth = availableSpace.width - availableSpace.leftRightIndent * 2
  const engineScoreHeight =  MOVEHISTORY_HEIGHT

  const moveHistoryPositionTop = engineScoreTop + engineScoreHeight
  const moveHistoryPositionLeft = availableSpace.leftRightIndent
  const moveHistoryHeight = (availableSpace.height - moveHistoryPositionTop) * .3
  const moveHistoryWidth = availableSpace.width - availableSpace.leftRightIndent * 2

  const infoWindowPositionTop = moveHistoryPositionTop + moveHistoryHeight
  const infoWindowPositionLeft = moveHistoryPositionLeft
  const infoWindowHeight = availableSpace.height - infoWindowPositionTop
  const infoWindowWidth = moveHistoryWidth

  // for the board builder
  const clipPositionTop = moveHistoryPositionTop
  const clipPositionLeft = boardPositionLeft
  const clipHeight = boardHeight * 2.0/8.0
  const clipWidth = boardWidth * 6.0/8.0

  const result = { 
    clipContainer : {
      width : clipWidth,
      height : clipHeight,
      left : clipPositionLeft + availableSpace.leftIndent,
      top : clipPositionTop+ availableSpace.topIndent
    },
    clipBoard : {
      width : boardWidth,
      height : boardHeight,
      left : + availableSpace.leftIndent,
      top : 0
    },
    board : {
      width : boardWidth,
      height : boardHeight,
      left : boardPositionLeft + availableSpace.leftIndent,
      top : boardPositionTop+ availableSpace.topIndent
    },
    topMove : {
      width : topMoveWidth,
      height : topMoveHeight,
      left : topMovePositionLeft + availableSpace.leftIndent,
      top : topMovePositionTop+ availableSpace.topIndent
    },
    bottomMove : {
      width : topMoveWidth,
      height : topMoveHeight,
      left : topMovePositionLeft + availableSpace.leftIndent,
      top : boardPositionTop + boardHeight - topMoveHeight + availableSpace.topIndent
    },
    info : {
      width : infoWindowWidth,
      height : infoWindowHeight,
      left : infoWindowPositionLeft + availableSpace.leftIndent,
      top : infoWindowPositionTop+ availableSpace.topIndent
    },
    history : {
      width : moveHistoryWidth,
      height : moveHistoryHeight,
      left : moveHistoryPositionLeft + availableSpace.leftIndent,
      top : moveHistoryPositionTop+ availableSpace.topIndent
    },
    score : {
      width : engineScoreWidth,
      height : engineScoreHeight,
      left : engineScoreLeft + availableSpace.leftIndent,
      top : engineScoreTop+ availableSpace.topIndent
    },
    onlineGames : {
      width : infoWindowWidth,
      height : infoWindowHeight,
      left : infoWindowPositionLeft + availableSpace.leftIndent,
      top : infoWindowPositionTop+ availableSpace.topIndent
    },
  }
  return (result)
}

function calculateLandscapeWidthHeights(availableSpace) {

  const availableSpaceForBoard = { width : (availableSpace.width - WHO_MOVE_WIDTH) / 4,
              height : availableSpace.height ,
              isPortrait : false }
  const boardDimensions = calculateChessBoardRect(availableSpaceForBoard,1.0)

  const boardHeight = boardDimensions.height
  const boardWidth = boardDimensions.width
  const boardPositionTop = boardDimensions.y
  const boardPositionLeft = boardDimensions.x + availableSpace.leftRightIndent

  const topMoveHeight = WHO_MOVE_HEIGHT
  const topMoveWidth = WHO_MOVE_WIDTH
  const topMovePositionTop = boardPositionTop
  const topMovePositionLeft = boardPositionLeft + boardWidth

   // grab the vertical for engine scoring
  const engineScoreTop = 0
  const engineScoreLeft = boardPositionLeft + boardWidth + topMoveWidth + availableSpace.leftRightIndent
  const engineScoreWidth = availableSpace.width - engineScoreLeft
  const engineScoreHeight = MOVEHISTORY_HEIGHT

  const moveHistoryPositionTop = engineScoreHeight
  const moveHistoryPositionLeft = boardPositionLeft + boardWidth + topMoveWidth + availableSpace.leftRightIndent
  const moveHistoryHeight = (availableSpace.height - engineScoreHeight) * .3
  const moveHistoryWidth = availableSpace.width - moveHistoryPositionLeft

  const infoWindowPositionTop = moveHistoryPositionTop + moveHistoryHeight
  const infoWindowPositionLeft = boardPositionLeft + boardWidth + topMoveWidth + availableSpace.leftRightIndent
  const infoWindowHeight = availableSpace.height - infoWindowPositionTop
  const infoWindowWidth = availableSpace.width - infoWindowPositionLeft

  // for the board builder
  const clipPositionTop = 0
  const clipPositionLeft = boardPositionLeft + boardWidth + topMoveWidth + availableSpace.leftRightIndent
  const clipHeight = boardHeight * 6.0/8.0
  const clipWidth = boardWidth * 2.0/8.0

  const result = { 
    clipContainer : {
      width : clipWidth,
      height : clipHeight,
      left : clipPositionLeft + availableSpace.leftIndent,
      top : clipPositionTop+ availableSpace.topIndent
    },
    topMove : {
      width : topMoveWidth,
      height : topMoveHeight,
      left : topMovePositionLeft + availableSpace.leftIndent,
      top : topMovePositionTop+ availableSpace.topIndent
    },
    bottomMove : {
      width : topMoveWidth,
      height : topMoveHeight,
      left : topMovePositionLeft + availableSpace.leftIndent,
      top : boardPositionTop + boardHeight - topMoveHeight + availableSpace.topIndent
    },
    clipBoard : {
      width : boardWidth,
      height : boardHeight,
      left : boardPositionLeft,
      top : boardPositionTop
    },
    board : {
      width : boardWidth,
      height : boardHeight,
      left : boardPositionLeft + availableSpace.leftIndent,
      top : boardPositionTop+ availableSpace.topIndent
    },
    info : {
      width : infoWindowWidth,
      height : infoWindowHeight,
      left : infoWindowPositionLeft + availableSpace.leftIndent,
      top : infoWindowPositionTop+ availableSpace.topIndent
    },
    history : {
      width : moveHistoryWidth,
      height : moveHistoryHeight,
      left : moveHistoryPositionLeft + availableSpace.leftIndent,
      top : moveHistoryPositionTop+ availableSpace.topIndent
    },
    score : {
      width : engineScoreWidth,
      height : engineScoreHeight,
      left : engineScoreLeft + availableSpace.leftIndent,
      top : engineScoreTop+ availableSpace.topIndent
    },
    onlineGames : {
      width : engineScoreWidth,
      height : availableSpace.height,
      left : engineScoreLeft + availableSpace.leftIndent,
      top : engineScoreTop+ availableSpace.topIndent
    },
  }
  //console.log("LANDSCAPE RESULT",result)
  return (result)
}


function safeJSONParse(str, fallback = null) {
    try {
        return JSON.parse(str);
    } catch {
        console.log("Parse Failed ->",str)
        return fallback;
    }
}

function handlePacket(json) {
  if (!json.hasOwnProperty('text'))
    return
  markdownText += json.text
  const displayMarkDownText = 
              (streamingGame) ? markdownText.replaceAll("`", "")
                                .replaceAll('～', '~')
                                .replace(/~white(\d{1,3})~/g, '[$1.](#w$1)')
                                .replace(/~black(\d{1,3})~/g, '[$1...](#b$1)') :
              markdownText.replaceAll("`", "")
                                .replace(/~([^~]+)~/g, (_, m) => `[${m}](#${m.replace(/[+#=]/g, '')})`)
  markdownHTML.value = md.render(displayMarkDownText)
}

// Called when the stream closes
function onStreamEnd() {
    // Handle anything left in the buffer
    const trimmed = streamLineBuffer.trim();
    if (trimmed) {
        try {
            const packet = JSON.parse(trimmed);
            handlePacket(packet);
        } catch (e) {
            console.error('Incomplete packet at stream end:', trimmed, e);
        }
    }
    streamLineBuffer = '';
}

// Called with each raw chunk from your PHP stream
function onChunk(chunk) {
    streamLineBuffer += chunk;
    
    // Split on newlines — we may have 0, 1, or several complete lines
    const lines = streamLineBuffer.split('\n');
    
    // Everything except the last element is a complete line
    // The last element is the incomplete remainder — put it back in the buffer
    streamLineBuffer = lines.pop();
    
    for (const line of lines) {
        const trimmed = line.trim();
        if (!trimmed) continue;  // skip blank lines
        
        try {
            const packet = JSON.parse(trimmed);
            handlePacket(packet);
        } catch (e) {
            console.error('Bad JSON line:', trimmed, e);
        }
    }
}

var controller = null; // We keep this in the outer scope

async function streamWithIterator(url,isGame,analysisType) {

  // 2. Initialize a new AbortController for this specific request
  controller = new AbortController();
  const signal = controller.signal;

  const params = new URLSearchParams();

  //const fens = '[{"f":"rnbqkbnr/pppppppp/8/8/4P3/8/PPPP1PPP/RNBQKBNR b KQkq - 0 1","n":"e4","c":"+0.43","s":"+0.47","b":"e4 c5","i":"","m":1,"p":"w"},{"f":"rnbqkbnr/ppp1pppp/8/3p4/4P3/8/PPPP1PPP/RNBQKBNR w KQkq - 0 2","n":"d5","c":"+0.75","s":"+0.43","b":"c5 Nf3 Nc6 Bb5 g6 O-O Bg7 Bxc6 bxc6 Re1 Qc7 c3 d6 h3","i":"","m":2,"p":"b"},{"f":"rnbqkbnr/ppp1pppp/8/3p4/4P3/2P5/PP1P1PPP/RNBQKBNR b KQkq - 0 2","n":"c3","c":"-0.93","s":"+0.75","b":"exd5 Nf6","i":"error","m":2,"p":"w"},{"f":"rnbqkbnr/ppp1pppp/8/8/4p3/2P5/PP1P1PPP/RNBQKBNR w KQkq - 0 3","n":"dxe4","c":"-0.98","s":"-0.93","b":"dxe4 d4","i":"","m":3,"p":"b"},{"f":"rnbqkbnr/ppp1pppp/8/8/Q3p3/2P5/PP1P1PPP/RNB1KBNR b KQkq - 1 3","n":"Qa4+","c":"-1.09","s":"-0.98","b":"d4","i":"","m":3,"p":"w"},{"f":"rn1qkbnr/pppbpppp/8/8/Q3p3/2P5/PP1P1PPP/RNB1KBNR w KQkq - 2 4","n":"Bd7","c":"-0.13","s":"-1.09","b":"Nc6 Qxe4 Nf6 Qc2 Qd5 Nf3 Bf5 Qb3 e5 Qxd5 Nxd5 d3 O-O-O Nh4 Be6 Nf3","i":"","m":4,"p":"b"},{"f":"rn1qkbnr/pppbpppp/8/8/4Q3/2P5/PP1P1PPP/RNB1KBNR b KQkq - 0 4","n":"Qxe4","c":"-0.12","s":"-0.13","b":"Qxe4","i":"","m":4,"p":"w"},{"f":"rn1qkbnr/ppp1pppp/2b5/8/4Q3/2P5/PP1P1PPP/RNB1KBNR w KQkq - 1 5","n":"Bc6","c":"+0.08","s":"-0.12","b":"Nc6","i":"","m":5,"p":"b"},{"f":"rn1qkbnr/ppp1pppp/2b5/8/8/2PQ4/PP1P1PPP/RNB1KBNR b KQkq - 2 5","n":"Qd3","c":"-4.71","s":"+0.08","b":"Qe2 Nf6","i":"error","m":5,"p":"w"},{"f":"rn2kbnr/pppqpppp/2b5/8/8/2PQ4/PP1P1PPP/RNB1KBNR w KQkq - 3 6","n":"Qd7","c":"-0.04","s":"-4.71","b":"Qxd3 Bxd3 Bxg2 f3 Bxh1 Be2 Nc6 d4 Nf6 Bf4 Nd5 Bg3","i":"miss","m":6,"p":"b"},{"f":"rn2kbnr/pppQpppp/2b5/8/8/2P5/PP1P1PPP/RNB1KBNR b KQkq - 0 6","n":"Qxd7+","c":"-0.50","s":"-0.04","b":"Qe2","i":"","m":6,"p":"w"},{"f":"r3kbnr/pppnpppp/2b5/8/8/2P5/PP1P1PPP/RNB1KBNR w KQkq - 0 7","n":"Nxd7","c":"-0.39","s":"-0.50","b":"Nxd7 Nf3 e5 Be2 Ne7 O-O e4 Nd4 Ne5 f3 Nd3 Na3 O-O-O Nc4 f5 Bxd3 exd3","i":"","m":7,"p":"b"},{"f":"r3kbnr/pppnpppp/2b5/8/8/2P2N2/PP1P1PPP/RNB1KB1R b KQkq - 1 7","n":"Nf3","c":"-0.32","s":"-0.39","b":"Nf3","i":"","m":7,"p":"w"},{"f":"r3kb1r/pppnpppp/2b2n2/8/8/2P2N2/PP1P1PPP/RNB1KB1R w KQkq - 2 8","n":"Ngf6","c":"-0.24","s":"-0.32","b":"e5 d4","i":"","m":8,"p":"b"},{"f":"r3kb1r/pppnpppp/2b2n2/8/3P4/2P2N2/PP3PPP/RNB1KB1R b KQkq - 0 8","n":"d4","c":"-0.36","s":"-0.24","b":"Be2","i":"","m":8,"p":"w"},{"f":"r3kb1r/pppn1ppp/2b1pn2/8/3P4/2P2N2/PP3PPP/RNB1KB1R w KQkq - 0 9","n":"e6","c":"-0.03","s":"-0.36","b":"Bxf3 gxf3","i":"","m":9,"p":"b"},{"f":"r3kb1r/pppn1ppp/2b1pn2/8/3P4/2P2NP1/PP3P1P/RNB1KB1R b KQkq - 0 9","n":"g3","c":"-5.25","s":"-0.03","b":"Be2 b5","i":"error","m":9,"p":"w"},{"f":"r3k2r/pppnbppp/2b1pn2/8/3P4/2P2NP1/PP3P1P/RNB1KB1R w KQkq - 1 10","n":"Be7","c":"-0.17","s":"-5.25","b":"Bxf3 Rg1 e5 Nd2 Bc6 dxe5 Nxe5 f4 Neg4 Bg2 O-O-O Bxc6 bxc6 Nc4 Re8+ Kf1","i":"miss","m":10,"p":"b"},{"f":"r3k2r/pppnbppp/2b1pn2/8/3P4/2P2NP1/PP3PBP/RNB1K2R b KQkq - 2 10","n":"Bg2","c":"-0.16","s":"-0.17","b":"Bg2 b5 O-O Nd5 Ne1 O-O Nd3 a5 Bd2 N7b6 Rc1 Rfd8 b3 a4","i":"","m":10,"p":"w"},{"f":"r4rk1/pppnbppp/2b1pn2/8/3P4/2P2NP1/PP3PBP/RNB1K2R w KQ - 3 11","n":"O-O","c":"-0.20","s":"-0.16","b":"b5 O-O","i":"","m":11,"p":"b"},{"f":"r4rk1/pppnbppp/2b1pn2/6B1/3P4/2P2NP1/PP3PBP/RN2K2R b KQ - 4 11","n":"Bg5","c":"-0.32","s":"-0.20","b":"O-O","i":"","m":11,"p":"w"},{"f":"r3r1k1/pppnbppp/2b1pn2/6B1/3P4/2P2NP1/PP3PBP/RN2K2R w KQ - 5 12","n":"Rfe8","c":"-0.19","s":"-0.32","b":"h6 Be3","i":"","m":12,"p":"b"},{"f":"r3r1k1/pppnbppp/2b1pB2/8/3P4/2P2NP1/PP3PBP/RN2K2R b KQ - 0 12","n":"Bxf6","c":"-0.33","s":"-0.19","b":"O-O h6 Bxf6 Bxf6 Rd1 Rac8 Nbd2 Nb6 Ne1 Bxg2 Kxg2","i":"","m":12,"p":"w"},{"f":"r3r1k1/pppn1ppp/2b1pb2/8/3P4/2P2NP1/PP3PBP/RN2K2R w KQ - 0 13","n":"Bxf6","c":"-0.29","s":"-0.33","b":"Bxf6 O-O","i":"","m":13,"p":"b"},{"f":"r3r1k1/pppn1ppp/2b1pb2/8/3P4/2P2NP1/PP3PBP/RN3RK1 b - - 1 13","n":"O-O","c":"-0.32","s":"-0.29","b":"O-O","i":"","m":13,"p":"w"},{"f":"r3r1k1/1ppn1ppp/2b1pb2/p7/3P4/2P2NP1/PP3PBP/RN3RK1 w - - 0 14","n":"a5","c":"-0.17","s":"-0.32","b":"e5 Na3","i":"","m":14,"p":"b"},{"f":"r3r1k1/1ppn1ppp/2b1pb2/p7/3P4/2P2NP1/PP1N1PBP/R4RK1 b - - 1 14","n":"Nbd2","c":"-0.17","s":"-0.17","b":"Nbd2 Red8 Rfd1 a4 Nc4 Kf8 Ne3 g6 a3","i":"","m":14,"p":"w"},{"f":"r3r1k1/2pn1ppp/2b1pb2/pp6/3P4/2P2NP1/PP1N1PBP/R4RK1 w - - 0 15","n":"b5","c":"-0.15","s":"-0.17","b":"a4 Rfe1","i":"","m":15,"p":"b"},{"f":"r3r1k1/2pn1ppp/2b1pb2/pp6/3P4/2P2NP1/PP1N1PBP/3R1RK1 b - - 1 15","n":"Rad1","c":"-0.18","s":"-0.15","b":"Rfd1 a4","i":"","m":15,"p":"w"},{"f":"r3r1k1/2pn1ppp/2b1pb2/p7/1p1P4/2P2NP1/PP1N1PBP/3R1RK1 w - - 0 16","n":"b4","c":"+0.01","s":"-0.18","b":"Bd5 Rfe1","i":"","m":16,"p":"b"},{"f":"r3r1k1/2pn1ppp/2b1pb2/p7/1pPP4/5NP1/PP1N1PBP/3R1RK1 b - - 0 16","n":"c4","c":"-0.57","s":"+0.01","b":"Rfe1 Red8","i":"","m":16,"p":"w"},{"f":"r3r1k1/2pn1ppp/4pb2/p7/bpPP4/5NP1/PP1N1PBP/3R1RK1 w - - 1 17","n":"Ba4","c":"-0.26","s":"-0.57","b":"Red8 Rfe1 a4 h4 g6 g4 Bb7 g5 Bg7 Ne4 Bxe4 Rxe4 Nb6 c5","i":"","m":17,"p":"b"},{"f":"r3r1k1/2pn1ppp/4pb2/p7/bpPP4/1P3NP1/P2N1PBP/3R1RK1 b - - 0 17","n":"b3","c":"-0.38","s":"-0.26","b":"b3 Bc6","i":"","m":17,"p":"w"},{"f":"r3r1k1/2pn1ppp/2b1pb2/p7/1pPP4/1P3NP1/P2N1PBP/3R1RK1 w - - 1 18","n":"Bc6","c":"-0.39","s":"-0.38","b":"Bc6","i":"","m":18,"p":"b"},{"f":"r3r1k1/2pn1ppp/2b1pb2/p7/1pPP4/1P3NP1/P2N1PBP/3RR1K1 b - - 2 18","n":"Rfe1","c":"-0.40","s":"-0.39","b":"Rfe1 Red8 Ne4 Bxe4 Rxe4 Ra6 Re2 Rd6 Red2 c5 d5 Bc3 Re2 Nf6 Ng5 exd5 cxd5 a4 bxa4","i":"","m":18,"p":"w"},{"f":"r3r1k1/2pn1ppp/2b1pb2/8/ppPP4/1P3NP1/P2N1PBP/3RR1K1 w - - 0 19","n":"a4","c":"+0.06","s":"-0.40","b":"Red8 Ne4","i":"","m":19,"p":"b"},{"f":"r3r1k1/2pn1ppp/2b1pb2/4N3/ppPP4/1P4P1/P2N1PBP/3RR1K1 b - - 1 19","n":"Ne5","c":"-0.02","s":"+0.06","b":"Ne5 Bxg2","i":"","m":19,"p":"w"},{"f":"r3r1k1/2p2ppp/2b1pb2/4n3/ppPP4/1P4P1/P2N1PBP/3RR1K1 w - - 0 20","n":"Nxe5","c":"-0.03","s":"-0.02","b":"Bxg2 Nxd7 Bc6 Nxf6+ gxf6 Ne4 Kg7 Nc5 Red8 f4 axb3 axb3 Bf3 Rd3 Bg4 Rd2 Ra3","i":"","m":20,"p":"b"},{"f":"r3r1k1/2p2ppp/2b1pb2/4P3/ppP5/1P4P1/P2N1PBP/3RR1K1 b - - 0 20","n":"dxe5","c":"-0.01","s":"-0.03","b":"dxe5","i":"","m":20,"p":"w"},{"f":"r3r1k1/2p2ppp/4pb2/4P3/ppP5/1P4P1/P2N1PbP/3RR1K1 w - - 0 21","n":"Bxg2","c":"-0.07","s":"-0.01","b":"Bxg2 Kxg2","i":"","m":21,"p":"b"},{"f":"r3r1k1/2p2ppp/4pb2/4P3/ppP5/1P4P1/P2N1PKP/3RR3 b - - 0 21","n":"Kxg2","c":"-0.07","s":"-0.07","b":"Kxg2 Be7","i":"","m":21,"p":"w"},{"f":"r3r1k1/2p1bppp/4p3/4P3/ppP5/1P4P1/P2N1PKP/3RR3 w - - 1 22","n":"Be7","c":"+0.00","s":"-0.07","b":"Be7 Ne4","i":"","m":22,"p":"b"},{"f":"r3r1k1/2p1bppp/4p3/4P3/ppP1N3/1P4P1/P4PKP/3RR3 b - - 2 22","n":"Ne4","c":"-0.02","s":"+0.00","b":"Ne4 Kf8 Rd7 Rec8 c5 Ke8 Rd4 Rcb8 Rc4 h5 h4 Ra5 Rd1 Rbb5 Rcd4 Rb8 Rc4","i":"","m":22,"p":"w"},{"f":"r3r1k1/2p1bppp/4p3/4P3/1pP1N3/1p4P1/P4PKP/3RR3 w - - 0 23","n":"axb3","c":"+0.00","s":"-0.02","b":"Kf8 Rd7","i":"","m":23,"p":"b"},{"f":"r3r1k1/2p1bppp/4p3/4P3/1pP1N3/1P4P1/5PKP/3RR3 b - - 0 23","n":"axb3","c":"+0.01","s":"+0.00","b":"axb3 Kf8 Rd7 Rec8 Red1 Ra3 R1d3 Ke8 g4 Ra5 f4 Ra2+ Rd2 Rca8 f5 R8a3 Rxa2 Kxd7 Rd2+ Kc6 f6 gxf6","i":"","m":23,"p":"w"},{"f":"4r1k1/2p1bppp/4p3/4P3/1pP1N3/1P4P1/r4PKP/3RR3 w - - 1 24","n":"Ra2","c":"+1.42","s":"+0.01","b":"f5","i":"miss","m":24,"p":"b"},{"f":"4r1k1/2p1bppp/4p3/4P3/1pP1N3/1P4P1/r2R1PKP/4R3 b - - 2 24","n":"Rd2","c":"-0.23","s":"+1.42","b":"Rd7 Ra5","i":"error","m":24,"p":"w"},{"f":"4r1k1/2p1bppp/4p3/4P3/1pP1N3/1P4P1/3r1PKP/4R3 w - - 0 25","n":"Rxd2","c":"-0.17","s":"-0.23","b":"Rxd2 Nxd2","i":"","m":25,"p":"b"},{"f":"4r1k1/2p1bppp/4p3/4P3/1pP5/1P4P1/3N1PKP/4R3 b - - 0 25","n":"Nxd2","c":"-0.24","s":"-0.17","b":"Nxd2","i":"","m":25,"p":"w"},{"f":"3r2k1/2p1bppp/4p3/4P3/1pP5/1P4P1/3N1PKP/4R3 w - - 1 26","n":"Rd8","c":"-0.14","s":"-0.24","b":"Ra8","i":"","m":26,"p":"b"},{"f":"3r2k1/2p1bppp/4p3/4P3/1pP1N3/1P4P1/5PKP/4R3 b - - 2 26","n":"Ne4","c":"-0.11","s":"-0.14","b":"Ne4 f5","i":"","m":26,"p":"w"},{"f":"6k1/2p1bppp/4p3/4P3/1pP1N3/1P1r2P1/5PKP/4R3 w - - 3 27","n":"Rd3","c":"+0.02","s":"-0.11","b":"f5 exf6 gxf6 g4 Kf7 Re3 Rd4 Re2 Bd6 Re1 h6 h3 Be7 Re3 h5 gxh5 f5 Ng3 Bd6 Ne2 Rh4 Rd3 Rxh5 c5 Rg5+","i":"","m":27,"p":"b"},{"f":"6k1/2p1bppp/4p3/4P3/1pP1N3/1P1r2P1/5PKP/1R6 b - - 4 27","n":"Rb1","c":"-0.72","s":"+0.02","b":"Ra1","i":"","m":27,"p":"w"},{"f":"6k1/2p1b1pp/4p3/4Pp2/1pP1N3/1P1r2P1/5PKP/1R6 w - f6 0 28","n":"f5","c":"-0.86","s":"-0.72","b":"f5 exf6 gxf6 Rb2 f5 Nd2 e5 Kf1 e4 Ke2 Rc3 Ra2 Kg7 Ra7","i":"","m":28,"p":"b"},{"f":"6k1/2p1b1pp/4p3/4PpN1/1pP5/1P1r2P1/5PKP/1R6 b - - 1 28","n":"Ng5","c":"-4.47","s":"-0.86","b":"exf6 gxf6","i":"error","m":28,"p":"w"},{"f":"6k1/2p3pp/4p3/4Ppb1/1pP5/1P1r2P1/5PKP/1R6 w - - 0 29","n":"Bxg5","c":"-4.55","s":"-4.47","b":"Bxg5 Ra1 Be7 Ra7 Kf7 Rxc7 Rxb3 c5 Ra3 c6 Rc3 f4 b3 Rb7 Rxc6 Rxb3","i":"","m":29,"p":"b"},{"f":"6k1/2p3pp/4p3/2P1Ppb1/1p6/1P1r2P1/5PKP/1R6 b - - 0 29","n":"c5","c":"-5.03","s":"-4.55","b":"h4 Be7 h5 Kf7 Kf1 Rc3 Ke2 Bc5 Ke1 Kf8 Ke2 Be7 Ke1 h6","i":"","m":29,"p":"w"},{"f":"6k1/2p3pp/4p3/2P1Ppb1/1p6/1P4P1/3r1PKP/1R6 w - - 1 30","n":"Rd2","c":"-4.57","s":"-5.03","b":"Be7 c6 Kf7 h4 Rc3 h5 Rxc6 Ra1 Rc2 Ra7 Rxf2+ Kxf2 Bc5+ Ke2 Bxa7 Kd3 g5 Kc4","i":"","m":30,"p":"b"},{"f":"6k1/2p3pp/4p3/2P1Ppb1/1p6/1P4P1/3r1PKP/R7 b - - 2 30","n":"Ra1","c":"-4.70","s":"-4.57","b":"Ra1 Be7 c6 Rc2 Ra8+ Kf7 Ra6 Rc5 h4 Rc3 h5 Rc5 h6 gxh6 Kh3 Rxe5 Ra8 Rc5 Rh8 Kg6","i":"","m":30,"p":"w"}]';
  
  streamingGame = isGame
  //console.log("GAME JSON",gameJsonString)
  params.append("fens", (isGame) ? gameJsonString : moveJsonString);
  params.append("hash", (isGame) ? gameHash : moveHash);
  params.append("analysis_type", analysisType);
  params.append("opening_name",openingName)

  //console.log("HASH",gameHash)
  //console.log("JSON for Stream",(isGame) ? gameJsonString : moveJsonString)

  streamIsWorking.value = true

  try {
      const response = await fetch(url, {
          method: 'POST',
          headers: {
            "Content-Type": "application/x-www-form-urlencoded"
          },
          body: params,
          signal: signal // Attach the signal here
      });

      const reader = response.body.getReader();
      const decoder = new TextDecoder();

      var lineBuffer = ""

      while (true) {
          const { value, done } = await reader.read();
          if (done) {
            //console.log("stream done")
            streamIsWorking.value = false
            break;
          }

          const text = decoder.decode(value);
          onChunk(text)
      }      
  } catch (err) {
      if (err.name === 'AbortError') {
            console.log( "\n[Generation stopped by user]")
      } else {
          console.error("Stream error:", err);
      }
  } finally {
      // 3. Reset UI state regardless of success or failure
      controller = null;
  }
  onStreamEnd()
  //console.log("stream end of function")
  streamIsWorking.value = false
}

// The Stop Button Logic
    // if (controller) {
    //     controller.abort(); // This triggers the 'AbortError' in the catch block
    // }

function startScoringTimer() {

  //console.log("Timer started.  ",calcScoreSeconds,timerCanStop)
  function oneSecondInterval() {
    if (timerCanStop) {
      clearInterval(id)
      return
    }
    calcScoreSeconds--
    if (calcScoreSeconds <= 0) {
      scoringSecondsLeft.value = t("Still Scoring")
      timerCanStop = true
      clearInterval(id)
    }
    else {
      scoringSecondsLeft.value = t("Scoring") + "..." + calcScoreSeconds + " " + t("secs")
    }
  }
  var id = setInterval(oneSecondInterval, 1000)
}

function scoreToString(scoreType,scoreValue) {
  var string = ""
  if (scoreType == "cp") {
    if (scoreValue < 0) {
      string = "-"
      scoreValue = -scoreValue
    }
    else
      string = "+"
    if (scoreValue >= 1000)
      scoreValue = 999
    if (scoreValue >= 100) {
      const hundreds = Math.trunc(scoreValue / 100)
      string += hundreds
    }
    else
      string += "0"
    string += "."
    scoreValue %= 100
    if (scoreValue >= 10) {
      const tens = Math.trunc(scoreValue / 10)
      string += tens
    }
    else
      string += "0"
    string += scoreValue % 10
  }
  else
  if (scoreType == "mate") {
    string = "mate " + scoreValue
  }
  else
    string = "unknown"
  return (string)
}

function parsePgn(chessHistory) {
  const pgnString = chess.pgn()
  //console.log("**** pgnString", pgnString)
  const pgnLines = pgnString.split("\n")

  // build what's needed to save on disk
  var sans = []
  var fens = []
  var tagKeys = []
  var tagValues = []

  for (var i=0; i < pgnLines.length; i++) {
    const str = pgnLines[i]

    // newline after the tags
    if (str.length == 0)
      break

    const firstChar = str[0];
    if (firstChar == "[") {
      const [key, value1] = str.slice(1, -1).split(/ (.+)/)
      // remove the quotes around the value
      const value = value1.slice(1, -1)
      //console.log("KEY",key)
      //console.log("VALUE",value)
      tagKeys.push(key)
      tagValues.push(value)
    }
  }

  for (var i=0; i < chessHistory.length; i++) {
    sans.push(chessHistory[i].san)
    fens.push(chessHistory[i].after)
  }
  const sansString = sans.join(" ")
  const fensString = fens.join("\t")
  //console.log("SAN STRING",sansString)
  //console.log("FEN STRING",fensString)
  saveGame(sansString,fensString,tagKeys.join("\t"),tagValues.join("\t"))
}

// take a full PGN or list of SANS from the saved ai_game entry
function pgnToTreeDisplay(pgn,sansString) {

  if (pgn != null) {
    try {
      chess.loadPgn(pgn)
    } catch {
      setupAlert("Clipboard does not contain a valid PGN","","alert","bad")
      return
    }
  }
  else {
    const sans = sansString.split(" ")
    //console.log("SANS ARRAY",sans)
    //console.log("FEN before clear",chess.fen())
    chess.reset()
    //console.log("FEN after clear",chess.fen())
    for (var i=0; i < sans.length; i++)
      chess.move(sans[i])
    //console.log("AFTER APPLY MOVES")
  }

  const chessHistory = chess.history({ verbose: true })
  //console.log("HISTORY ",chessHistory)
  parsePgn(chessHistory)

  const startingFen = (chessHistory.length > 0) ? chessHistory[0].before : INITIAL_FEN
  loadRepTreeFromChessHistory(startingFen,chessHistory,0,false,true)

  // take the tree and build up the PGN sans list. Fens list to get scored
  var sans = []
  var fens = []
  fens.push(INITIAL_FEN)
  for (var i=1; i < treeDisplay.value[0].moves.length; i++) {
    sans.push(treeDisplay.value[0].moves[i].move.san)
    fens.push(treeDisplay.value[0].moves[i].move.fen)
  }
  //console.log("*** FENS FROM PGN",fens)

  showInfoState.value = SHOW_SCORING_GAME

  getScoreGame(fens)
  pgnSans = sans.join(" ")
  pgnIndex = 0
  isPGN = true
  isPGNDisplayed = true
  //setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_MAIN_BACK_TO_GAME,true)
  toolbarTrigger.value++
}

function loadRepTreeFromChessHistory(startingFen,chessHistory,selectedIndex,firstCall,iMadeTheMove) {
  var updatedFen = startingFen

  const startingFenPieces = startingFen.split(" ")
  const startingPlyNumber = (startingFenPieces[1] == "w") ? 0 : 1

  var oneBranch = { indentLevel : 0, moves : [] }

  // initial clickable thing -- allow for PGN that is a game fragment
  const firstFen = (chessHistory.length > 0) ? chessHistory[0].before : startingFen

  if (selectedIndex == 0)
    updatedFen = firstFen

  var firstBranchElement = { index : 0, ply : -1, isOpen : false, selected : (selectedIndex == 0), parentIsOpen : false, 
            move :{  san : "First", fen : firstFen,
                first_move_not_addressed : 0, percent : 0, comment : '', canBranchAfterThisMove : false , branchIsOpen : false
              }
            }
  oneBranch.moves.push(firstBranchElement)
  for (var i=0; i < chessHistory.length; i++) {
    if (selectedIndex == i+1)
      updatedFen = chessHistory[i].after
    var oneBranchElement = { index : i+1, ply : i + startingPlyNumber, isOpen : false, selected :  (selectedIndex == i+1), parentIsOpen : (i == 0), 
            move : { san : chessHistory[i].san, fen : chessHistory[i].after, first_move_not_addressed : 0, 
                      percent : 0, comment : '', canBranchAfterThisMove : false , branchIsOpen : false} }
    oneBranch.moves.push(oneBranchElement)
  }
  treeDisplay.value = [oneBranch]
  //console.log("in loadreptree",treeDisplay.value)
  scoreDisplayString.value =  ""
  treeTrigger.value++

  //console.log("before get board ",fen.value,updatedFen)
  const currentLoad = chess.load(fen.value.trim())
  const currentBoard = chess.board()
  const updatedLoad = chess.load(updatedFen)
  const updatedBoard = chess.board()

  const currentFen = fen.value
  animateFen.value = [currentFen , updatedFen]

  const fenPieces = updatedFen.split(" ")
  whiteToMove.value = (fenPieces[1] == "w")
  //console.log("before GET AVILALBLE")
  getAvailableMoves(updatedFen,iMadeTheMove)
  //console.log("after GET AVILALBLE")
  currentSelectedMoveIndex = selectedIndex

  // went back to the game, put up the score
  const engineScoreEntry = engineScoreMap.get(updatedFen.trim())
  if (engineScoreEntry != null) {
    scoreDisplayString.value = "White's 1st Best Move is: " + engineScoreEntry.bestMove + " with score of " + engineScoreEntry.scoreDisplay
  }
  else {
    // we don't have this move scored, so get it.  make an array of the one fen
    const fens = [updatedFen.trim()]
    getScoreGame(fens)
  }

    setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_MAIN_BACK, currentSelectedMoveIndex == 0)
    setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_MAIN_FORWARD, currentSelectedMoveIndex >=  oneBranch.moves.length -1)
    toolbarTrigger.value++
}

function formatDate(date,separator) {
  const year = date.toLocaleString('default', {year: 'numeric'});
  const month = date.toLocaleString('default', {
    month: '2-digit',
  });
  const day = date.toLocaleString('default', {day: '2-digit'});

  return [year, month, day].join(separator);
}

function fenSansToTreeDisplay(startingFen,sansString,selectedIndex,iMadeTheMove) {
  //console.log("StartFen ",startingFen,sansString)
  chess.load(startingFen)

  if (sansString.length > 0) {
    const sans = sansString.split(" ")
    for (var i=0; i < sans.length; i++)
      chess.move(sans[i])
  }

  const chessHistory = chess.history({ verbose: true })
  loadRepTreeFromChessHistory(startingFen,chessHistory,selectedIndex,false,iMadeTheMove)
}

function shiftSelectedMove(direction) {

  //console.log("current selected",currentSelectedMoveIndex)
  //console.log("tree size",treeDisplay.value[0].moves.length)

  if (direction == "back") {
    if (currentSelectedMoveIndex > 0)
      repTreeMoveClick(treeDisplay.value[0].moves[currentSelectedMoveIndex-1])

  }
  else {
    if (currentSelectedMoveIndex < treeDisplay.value[0].moves.length - 1)
      repTreeMoveClick(treeDisplay.value[0].moves[currentSelectedMoveIndex+1])
  }

    //console.log("before disable current selected",currentSelectedMoveIndex)

  setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_MAIN_BACK, currentSelectedMoveIndex == 0)
  setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_MAIN_FORWARD, currentSelectedMoveIndex >=  treeDisplay.value[0].moves.length -1)
  toolbarTrigger.value++
}

function interestingMoveClick(interestingMove) {
  //console.log("INTERESTING MOVE CLICK",interestingMove)
  //console.log("INTERESTING MOVE CLICK",interestingMove.moveIndex)
  //console.log("INTERESTING MOVE BRANCH",treeDisplay.value[0].moves[interestingMove.moveIndex])

  for (var i=0; i < interestingMoveDisplayArray.value.length; i++)
    interestingMoveDisplayArray.value[i].selected = false
  interestingMove.selected = true
  // position at move 
  repTreeMoveClick(treeDisplay.value[0].moves[interestingMove.moveIndex])
}

function moveChoiceClick(moveChoice) {
  //console.log("MOVE CHOICE CLICK",moveChoice)
  for (var i=0; i < moveChoiceDisplayArray.value.length; i++)
    moveChoiceDisplayArray.value[i].selected = false
  moveChoice.selected = true
  const fromUCI = moveChoice.uci.substring(0,2)
  const toUCI = moveChoice.uci.substring(2,4)
  const arrowString = fromUCI + "-" + toUCI + "-" + "yellow"
  //console.log("arrow String",arrowString)
  arrowPairs.value = [arrowString]
}

function repTreeBranchClick(branchElement) {
  //console.log("Branch Click",branchElement)
}

function repTreeMoveClick(branchElement) {
  
  // move changed, if on move choice list or move analysis, close that out
  if (showInfoState.value == SHOW_MOVE_ANALYSIS || showInfoState.value == SHOW_MOVE_CHOICES)
    showInfoState.value = SHOW_INTERESTING_MOVES

  arrowPairs.value = []
  //console.log("**** in move click",branchElement)

  const fenPieces = branchElement.move.fen.split(" ")
  whiteToMove.value = (fenPieces[1] == "w")
  //console.log("in reptreemove click white to move",whiteToMove.value)
  fen.value = branchElement.move.fen
  for (var i=0; i < treeDisplay.value[0].moves.length; i++) {
    treeDisplay.value[0].moves[i].selected = (i == branchElement.index)
  }
  currentSelectedMoveIndex = branchElement.index
  //console.log("after selected",treeDisplay.value[0])

  const engineScoreEntry = engineScoreMap.get(fen.value)
  if (engineScoreEntry != null) {
    const scoreColor = (fenPieces[1] == "w") ? "White's" : "Black's"
    const scoreMoveNumber = ordinal(Math.trunc(currentSelectedMoveIndex /2) + 1)
    scoreDisplayString.value = scoreColor + " best " + scoreMoveNumber + " move is: " + engineScoreEntry.bestMove + " with score of " + engineScoreEntry.scoreDisplay

    /* ignore this for now. the display gets complicated
    //console.log("Current index",currentSelectedMoveIndex,treeDisplay.value[0].moves.length)
    if (currentSelectedMoveIndex < treeDisplay.value[0].moves.length -1) {
      const nextMove = treeDisplay.value[0].moves[currentSelectedMoveIndex+1].move
      const nextFen = nextMove.fen
      //console.log("NEXT MOVE",nextMove,nextFen)
      const nextEngineScoreEntry = engineScoreMap.get(nextFen)
      //console.log("NEXTFEN",nextFen,nextEngineScoreEntry)
      if (nextEngineScoreEntry != null) {
        scoreDisplayString.value += "(Played=" + nextEngineScoreEntry.scoreDisplay + ")"
      }
    }
    */
  }
  else {
    // we don't have this move scored, so get it.  make an array of the one fen
    const fens = [branchElement.move.fen]
    getScoreGame(fens)
  }

  treeTrigger.value++

  getAvailableMoves(fen.value,false)

  //console.log("current index and # of moves",currentSelectedMoveIndex,treeDisplay.value[0].moves.length)
 
  setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_MAIN_BACK, currentSelectedMoveIndex == 0)
  setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_MAIN_FORWARD, currentSelectedMoveIndex >=  treeDisplay.value[0].moves.length -1)
  //console.log("ELEMENTS",toolbarElements.value);
  toolbarTrigger.value++
}

function appendMoveToTree(san,fen) {

  const firstBranchElement = treeDisplay.value[0].moves[0]

  const startingFenPieces = firstBranchElement.move.fen.split(" ")
  const startingPlyNumber = (startingFenPieces[1] == "w") ? 0 : 1

  // if currently displaying the PGN then save the current index as the place to return to in the PGN
  if (isPGNDisplayed) {
    pgnIndex = currentSelectedMoveIndex
    isPGNDisplayed = false
    //setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_MAIN_BACK_TO_GAME,false)
    toolbarTrigger.value++
  }

  var oneBranchElement = { 
      index : treeDisplay.value[0].moves.length,
      ply : treeDisplay.value[0].moves.length-1 + startingPlyNumber,
      isOpen : false, selected : false, parentIsOpen : (treeDisplay.value[0].moves.length == 1), 
      move : { san : san, fen : fen, first_move_not_addressed : 0, 
                      percent : 0, comment : '', canBranchAfterThisMove : false , branchIsOpen : false} }
  treeDisplay.value[0].moves.push(oneBranchElement)
}

function buildPGNForClipboard() {

  const todayDate = formatDate(new Date(),".")

  const chessOutput = new Chess()
  chessOutput.load(treeDisplay.value[0].moves[0].move.fen)
  chessOutput.header('Event','Chessvis.com AI','Date',todayDate,'Round','1','White','White','Black','Black','Result','*')

  for (var i=1; i < treeDisplay.value[0].moves.length; i++)
    chessOutput.move(treeDisplay.value[0].moves[i].move.san)

  const pgnText = chessOutput.pgn()
  //console.log("**** PGN ",pgnText)

  return (pgnText)
}

function boardMove(arrayIndex,fromUCI,toUCI,fromNumber,toNumber) {

  // viewer mode can't make moves
  if (isViewerMode) {
    availableMoves.value = []
    return
  }

  if (showState.value == SHOW_ROOM) {
    // if in the room and markup
    if (!showMoves.value)
      return
  }

  if (arrayIndex < 0)
    return

  //console.log("board move",arrayIndex,fromUCI,toUCI,fromNumber,toNumber)
  const oneMove = availableMoves.value[arrayIndex]
  //console.log("MOVE INFO ",oneMove.fen,oneMove.san)

  // if the move is the next move in sequence, then just do a 'forward'
  //    if not, truncate the sequence and append
  if (currentSelectedMoveIndex < treeDisplay.value[0].moves.length-1) {
    //console.log("NEXT FEN",treeDisplay.value[0].moves[currentSelectedMoveIndex+1].move.fen)
    if (oneMove.fen == treeDisplay.value[0].moves[currentSelectedMoveIndex+1].move.fen) {
      shiftSelectedMove("forward")
    }
    else {
      treeDisplay.value[0].moves.length = currentSelectedMoveIndex + 1
      appendMoveToTree(oneMove.san,oneMove.fen)
      shiftSelectedMove("forward")
    }
  }
  else {
    appendMoveToTree(oneMove.san,oneMove.fen)
    shiftSelectedMove("forward")
  }

}

function moveMade(moveFen,uci) {
  if (showState.value == SHOW_ROOM) {

    // if in the room, only interested in this if in markup mode
    if (showMoves.value)
      return

  }

  //console.log("MOVE MADE",moveFen,uci) 
  const moveChar = (whiteToMove.value) ? " w " : " b "
  completeFen = moveFen + moveChar + "KQkq - 0 1"
  const rc = validateFen(completeFen)
  //console.log("validation",rc)
  positionIsValid = rc.ok
  setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_BUILD_DONE,!positionIsValid)
  toolbarTrigger.value++
}

// callback from the 2x6 piece board
function boardSelector(arrayIndex,fromUCI,toUCI,fromNumber,toNumber) {
  //console.log("board SELECTOR",arrayIndex,fromUCI,toUCI,fromNumber,toNumber)

  const currentSideCarPiece = sideCarPiece.value

  // landscape is down, portrait is across
  switch (fromUCI) {
    case "a8" :
      sideCarPiece.value = "br"
      break
    case "a7" :
      sideCarPiece.value = (isPortrait) ? "wr" : "bn"
      break
    case "a6" :
    case "c8" :
      sideCarPiece.value = "bb"
      break
    case "a5" :
    case "d8" :
      sideCarPiece.value = "bq"
      break
    case "a4" :
    case "e8" :
      sideCarPiece.value = "bk"
      break
    case "f8" :
    case "a3" :
      sideCarPiece.value = "bp"
      break
    case "b8" :
      sideCarPiece.value = (isPortrait) ? "bn" : "wr"
      break
    case "b7" :
      sideCarPiece.value = "wn"
      break
    case "c7" :
    case "b6" :
      sideCarPiece.value = "wb"
      break
    case "d7" :
    case "b5" :
      sideCarPiece.value = "wq"
      break
    case "e7" :
    case "b4" :
      sideCarPiece.value = "wk"
      break
    case "f7" :
    case "b3" :
      sideCarPiece.value = "wp"
      break
  }

  if (currentSideCarPiece == sideCarPiece.value) {
    squareColorArray.value = [ ]
    sideCarPiece.value = ""
  }
  else
    squareColorArray.value = [ { square : fromUCI , color : "red"}]
}

function validatePasteFen(pasteFen) {
  //console.log(pasteFen)
  const rc = validateFen(pasteFen)
  if (rc.ok) {
    positionIsValid = true
    incrementAppendTrigger()
    fen.value = pasteFen + blankAppendTrigger
    completeFen = pasteFen
    const fenPieces = completeFen.split(" ")
    whiteToMove.value = (fenPieces[1] == "w")
    setToolbarElementLabel(toolbarElements.value,TOOLBAR_BUILD_WHO_MOVE,
                (whiteToMove.value) ? "White to Move" : "Black to Move")
    setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_BUILD_DONE,!positionIsValid)
    toolbarTrigger.value++
  }
  else {
    //console.log("validation",rc)
    alert("Clipboard does not contain a valid FEN")
  }
}

function alertResult(response,task,info) {
  //console.log("Alert Result",response,task)

  switch (task) {
    case "bad" : // bad pgn or fen
      break
    case "copy" :
      switch (response) {
        case "no" :
          return
        case "fen" :
          navigator.clipboard.writeText(fen.value.trim());
          break
        case "pgn" :
          navigator.clipboard.writeText(buildPGNForClipboard())
          break
      }
      break
    case "boardsource" :
      // build board responses
      switch (response) {
        case "no" :
          return
        case "initial" :
          incrementAppendTrigger()
          fen.value = INITIAL_FEN + blankAppendTrigger
          completeFen = INITIAL_FEN
          positionIsValid = true
          setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_BUILD_DONE,!positionIsValid)

          whiteToMove.value = true
          setToolbarElementLabel(toolbarElements.value,TOOLBAR_BUILD_WHO_MOVE,"White to Move")
          toolbarTrigger.value++
          break
        case "empty" :
          incrementAppendTrigger()
          fen.value = EMPTY_FEN + blankAppendTrigger
          completeFen = EMPTY_FEN
          positionIsValid = false
          setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_BUILD_DONE,!positionIsValid)
          whiteToMove.value = true
          setToolbarElementLabel(toolbarElements.value,TOOLBAR_BUILD_WHO_MOVE,"White to Move")
          toolbarTrigger.value++
          break
        case "paste" :
          navigator.clipboard.readText().then((clipText) => (
            validatePasteFen(clipText)
            ));
          break
      }
    break
  }
}

function buildBoardToolbarClick(arrayIndex) {

  var completePieces = []

  switch (arrayIndex) {
    case TOOLBAR_BUILD_PGN :
      navigator.clipboard.readText().then((clipText) => {
        isPGN = true
        pgnToTreeDisplay(clipText,null)
        buildBoardToolbarClick(TOOLBAR_BUILD_DONE_FROM_PGN)
      });
      break

    case TOOLBAR_BUILD_FEN :
      alertInfo.value = { header : "Board Source" , 
              message : "Preset Board to:", type : "boardsource", task : "boardsource"  }
      alertTrigger.value++
      break
    case TOOLBAR_BUILD_WHO_MOVE :
      whiteToMove.value = !whiteToMove.value
      const moveChar = (whiteToMove.value) ? "w" : "b"
      completePieces = completeFen.split(" ")
      completePieces[1] = moveChar
      completeFen = completePieces.join(" ")
      setToolbarElementLabel(toolbarElements.value,TOOLBAR_BUILD_WHO_MOVE,
                (whiteToMove.value) ? "White to Move" : "Black to Move")
      break
    case TOOLBAR_BUILD_DONE :
    case TOOLBAR_BUILD_DONE_FROM_PGN :

      squareColorArray.value = []
      mainSquareColorArray.value = []
      sideCarPiece.value = ""
      toolbarElements.value = JSON.parse(JSON.stringify(toolbarMainElements))
      toolbarTrigger.value++
      showState.value = SHOW_ROOM

      // fix up the castling based on where the pieces are
      if (arrayIndex == TOOLBAR_BUILD_DONE) {
        pgnSans = ""
        pgnIndex = 0
        isPGN = false
        isPGNDisplayed = false
        chess.load(completeFen)
        const board = chess.board()
        const cleanCastling = buildCastleString(board)
        completePieces = completeFen.split(" ")
        completePieces[2] = cleanCastling
        completeFen = completePieces.join(" ")

        incrementAppendTrigger()
        fen.value = completeFen + blankAppendTrigger

        //console.log("**** BACK FROM BUILD",completeFen)
        loadRepTreeFromChessHistory(completeFen,[],0,true,false)
      }
      break
  }
}

// stuff for options

function moveAnalysis() {
  showInfoState.value = SHOW_MOVE_ANALYSIS
  markdownHTML.value = md.render("<h1>*** Running Move Analysis</h1>")
  markdownText = ""
  const webURL = getWebSiteURL()
  streamWithIterator(webURL + "ai_run_llm_server.php",false,"move")
}

function moveChoices() {
  moveChoiceDisplayArray.value = []
  moveChoiceColor.value = (currentSelectedMoveIndex % 2 == 0) ? "White" : "Black"
  moveChoiceNumber.value = (Math.trunc((currentSelectedMoveIndex-1) /2)) + 1
  moveChoiceSan.value = treeDisplay.value[0].moves[currentSelectedMoveIndex].move.san
  //console.log("MOVE CHOICES", treeDisplay.value[0].moves[currentSelectedMoveIndex])
  getMoveChoices(treeDisplay.value[0].moves[currentSelectedMoveIndex].move.fen)
  showInfoState.value = SHOW_MOVE_CHOICES
}

// Start ACTION LIST
function actionSheetResult(action,index) {
  if (action != "yes")
    return
  actionClick(index)
}

function setupAlert(header,message,type,task) {
  alertInfo.value = { header : header, message : message, type : type, task : task  }
  alertTrigger.value++
}

function actionClick(index) {
  switch (index) {
    case ACTION_COACH_OPTION_COPY :
      setupAlert("Copy to Clipboard?","You can copy the current board or entire move sequence to the clipboard","boardmoves","copy")
      break
    case ACTION_COACH_OPTION_FLIP_BOARD :
      orientation.value = (orientation.value == "white") ? "black" : "white"
      break
    case ACTION_COACH_OPTION_BUILD_BOARD:
      squareColorArray.value = []
      mainSquareColorArray.value = []
      toolbarElements.value = toolbarBuildBoardElements
      toolbarTrigger.value++
      availableMoves.value = availableMovesForBuilder
      orientation.value = "white"
      incrementAppendTrigger()
      selectorFen.value = ((isPortrait) ? SELECTOR_FEN_PORTRAIT : SELECTOR_FEN_LANDSCAPE) + blankAppendTrigger
      showState.value = SHOW_BUILD_BOARD
      break
   
    case ACTION_AI_OPTION_INTERESTING_MOVE :
      showInfoState.value = SHOW_INTERESTING_MOVES
      break
    case ACTION_AI_OPTION_MOVE_CHOICES :
      doMoveAnalysis = false
      moveChoices()
      break
    case ACTION_AI_OPTION_GAME_ANALYSIS :
    case ACTION_AI_OPTION_GAME_OVERVIEW :
      showInfoState.value = SHOW_GAME_ANALYSIS

      markdownHTML.value = md.render("<h1>*** Running Game Analysis</h1>")
      markdownText = ""
      const webURL = getWebSiteURL()
      streamWithIterator(webURL + "ai_run_llm_server.php",true,
                  (index == ACTION_AI_OPTION_GAME_OVERVIEW) ? "game_short" : "game")

      break
    case ACTION_AI_OPTION_MOVE_ANALYSIS :
      doMoveAnalysis = true
      moveChoices()
      break
  }
}

// END Action List

function mainToolBarClick(arrayIndex) {
  var message = ""

  // trap that the button should be disabled but the screen hasn't caught up
  var element = findToolbarElement(toolbarElements.value,arrayIndex)
  if (element != null && element.disabled)
    return

  switch (arrayIndex) {
    case TOOLBAR_MAIN_FORWARD :
      shiftSelectedMove("forward")
      break
    case TOOLBAR_MAIN_BACK :
      shiftSelectedMove("back")
      break
    case TOOLBAR_PASTE_GAME :
      navigator.clipboard.readText().then((clipText) => {
        isPGN = true
        pgnToTreeDisplay(clipText,null)
        //buildBoardToolbarClick(TOOLBAR_BUILD_DONE_FROM_PGN)
      });
      break
    case TOOLBAR_MAIN_BACK_TO_GAME :
      if (isPGN == false || isPGNDisplayed == true)
        break

      const startingFen = treeDisplay.value[0].moves[0].move.fen
      const sans = pgnSans
      isPGNDisplayed = true
      currentSelectedMoveIndex = pgnIndex
      fenSansToTreeDisplay(startingFen,sans,pgnIndex,true)
      setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_MAIN_BACK_TO_GAME,true)
      toolbarTrigger.value++
      break
    case TOOLBAR_MAIN_COACH :
      actionSheetButtons.value = coachActionSheetButtons
      actionSheetTrigger.value++
      break
    case TOOLBAR_MAIN_AI :
      moveChoiceColor.value = (currentSelectedMoveIndex % 2 == 0) ? "White" : "Black"
      moveChoiceNumber.value = (Math.trunc((currentSelectedMoveIndex-1) /2)) + 1
      moveChoiceSan.value = treeDisplay.value[0].moves[currentSelectedMoveIndex].move.san

      aiActionSheetButtons[1].text = "Calculate " + moveChoiceColor.value + "'s move choices after " + moveChoiceNumber.value + 
                  ((moveChoiceColor.value == "Black") ? "." : "...") + moveChoiceSan.value
      actionSheetButtons.value = aiActionSheetButtons
      actionSheetTrigger.value++
      break
    case TOOLBAR_MAIN_FLIP :
      orientation.value = (orientation.value == "white") ? "black" : "white"
      break
  }
}

function toolbarClick(arrayIndex) {
  //console.log("toolbar click",showState,arrayIndex)
  switch (showState.value) {
    case SHOW_BUILD_BOARD :
      buildBoardToolbarClick(arrayIndex)
      break
    case SHOW_ROOM :
      mainToolBarClick(arrayIndex)
      break
  }
}

function getAvailableMoves(fenString,noNeedToCallEngine) {

  // viewer mode can't make moves
  if (isViewerMode) {
    availableMoves.value = []
    return
  }

  //console.log("******* IN AVAILABLE MOVES",fenString)
  // var fenPieces = fen.split(" ")
  // fenPieces[5] = 1
  // const fenFixed = fenPieces.join(" ")
  chess.load(fenString)
  const moves = chess.moves({ verbose: true })
  availableMoves.value = buildAvailableMoves(moves,true)
  //console.log("available moves",availableMoves.value)

}

function scrollToId(id) {
  const yOffset = document.getElementById(id).offsetTop;
  content.value.$el.scrollToPoint(0,yOffset -100 ,200)
}

function errorHandler(error) {
  console.log("################################## -> ",error);
}

// takes blank separated list of UCI and gives back SAN string
function ucisToSans(fen,uciString,maxDepth) {
  chess.load(fen)

  // did we have a mate?
  if (uciString == "")
    return ("")

  const ucis = uciString.split(" ")
  var sans = []
  var count = (maxDepth < ucis.length) ? maxDepth : ucis.length
  for (var i=0; i < count; i++) {
    const move = chess.move(ucis[i])
    sans.push(move.san)
  }
  return (sans.join(" "))
}

function processGameScoreResponse(json) {
  //console.log(" process game score callback",json)
  if (json.hasOwnProperty('error')) {
    openErrorModal(json['programRun'],json['error'])
    return;
  }

  const sentFens = json['fens'].split("\t")
  var gameJson = []

  interestingMoveDisplayArray.value = []
  var prevPv = null
  var pvs = []

  // initial stockfish score is about +40
  var previousScoreValue = 40

  for (var i=0; i < sentFens.length; i++) {
    const fieldName = "fen_pvs" + i
    const entry = json[fieldName].split(",")
    var onePv = {
      depth : entry[1],
      scoreType : entry[2],
      scoreValue : parseInt(entry[3]),
      scoreDisplay : scoreToString(entry[2],entry[3]),
      bestMoves : ucisToSans(sentFens[i],entry[4],6)
    }
    const bestMoves = onePv.bestMoves.split(" ")
    onePv.bestMove = bestMoves[0]
    engineScoreMap.set(sentFens[i],onePv)

    var interestingMoveColor = ""
    var interestingMoveType = ""

    // first entry is the initial board position. i=1 is 1w & i=2 is 1b
    const moveNumber = Math.trunc((i-1)/2) + 1

    // display the initial board score and move
    if (i == 0) {
      scoreDisplayString.value = "White's Best 1st Move is: " + onePv.bestMove + " with score of " + onePv.scoreDisplay
    }
    else {
      //console.log("INDEX",i)
      //console.log("ONEPV",onePv)
      //console.log("PREVPV",prevPv)

      // need to not worry about mate sequences longer than # of moves
      //      they're okay for stockfish but not humans. I.e. "missing" them is not "interesting"
      //      even going from a mate to big "CP" isn't interesting
      const interestingMateMoveNumber = 3
      const interestingCpDifferential = 75
      const interstingAlreadyWinningCp = 300
      var currentScoreValue = onePv.scoreValue
      if (onePv.scoreType == "mate")
        if (onePv.scoreValue <= interestingMateMoveNumber && onePv.scoreValue >= 0)
          currentScoreValue = 64000
        else
        if (onePv.scoreValue >= -interestingMateMoveNumber && onePv.scoreValue < 0)
          currentScoreValue = -64000
        else
          currentScoreValue = previousScoreValue

      // ignore changes when score is already large.  White making a move that goes from +6 to +4.5 is unimportant
      if ((currentScoreValue >= interstingAlreadyWinningCp && 
              prevPv.scoreValue >= interstingAlreadyWinningCp) ||
              (onePv.scoreValue <= -interstingAlreadyWinningCp && 
                prevPv.scoreValue <= -interstingAlreadyWinningCp)) {
          interestingMoveColor = ""
      }
      else
      if (onePv.scoreValue - prevPv.scoreValue < -interestingCpDifferential) {
        interestingMoveColor = "w"
        interestingMoveType = ((i %2) == 1) ? "error" : "miss"
      }
      else
      if (onePv.scoreValue - prevPv.scoreValue > interestingCpDifferential) {
        interestingMoveColor = "b"
        interestingMoveType = ((i %2) == 1) ? "error" : "miss"
      }
      if (interestingMoveColor != "") {
        const interestingMove = {
          id : i,
          infoType : "interesting",
          fen : treeDisplay.value[0].moves[i].move.fen,
          san : treeDisplay.value[0].moves[i].move.san,
          colorName : (interestingMoveColor == "w") ? "White" : "Black",
          displaySan : moveNumber + ((interestingMoveColor == "w") ? "." : "...") + " " + treeDisplay.value[0].moves[i].move.san,
          moveIndex : i,
          interestingMoveType : interestingMoveType,
          yourScoreDisplay : onePv.scoreDisplay,
          bestScoreDisplay : prevPv.scoreDisplay,
          bestMove : prevPv.bestMove,
          selected : false
        }
        //console.log("INTERESTING MOVE",interestingMove)
        interestingMoveDisplayArray.value.push(interestingMove)
        // console.log("INTERESTING MOVE",interestingMoveColor,interestingMoveType,
        //       onePv.scoreType,onePv.scoreValue,prevPv,
        //       i,treeDisplay.value[0].moves[i].move.san,treeDisplay.value[0].moves[i].move.fen)
      }

      const onePly = {
        // these map to fen, sanPlayed, scoreForSanPlayed, scoreForBestContinuation, bestContinuation

        // fens, san, opponent_san come from ai_game table
        // send the response which is the opponent's SAN
        // score, best_score, best come from the ai_game & ai_single_move tables
        interesting : (interestingMoveColor != "") ? interestingMoveType : ""
      }
      gameJson.push(onePly)
    }
    prevPv = onePv
    previousScoreValue = currentScoreValue
  }

  gameJsonString = JSON.stringify(gameJson)
  //console.log("*** NEW ENGINE SCORE MAP",engineScoreMap)
  //console.log(gameJson)
  //console.log("GAME JSON",gameJsonString)
  timerCanStop = true

  // if nothing interesting, let them know
  if (interestingMoveDisplayArray.value.length == 0) {
    const interestingMove = {
      id : 0,
      infoType : "interesting",
      fen : "",
      san : "",
      displaySan : "",
      moveIndex : i,
      interestingMoveType : (treeDisplay.value[0].moves.length <= 1) ?
                "Paste In A Game PGN for Analysis           " :
                "Well Played, No moves on either side were of note",
      yourScoreDisplay : "",
      bestScoreDisplay : "",
      bestMove : ""
    }
    interestingMoveDisplayArray.value.push(interestingMove)
  } 
  showInfoState.value = SHOW_INTERESTING_MOVES
}

 function getScoreGame(fens) {
    
    showInfoState.value = SHOW_SCORING_GAME
    calcScoreSeconds = Math.trunc(fens.length / 15) + 2
    timerCanStop = false
    startScoringTimer()

    var formData = {
      fens : fens.join("\t"),
      key : "blah",
      pv : "1",
      time : "250"
    }

    //console.log("FORMDATA",formData)
    useGetData("get_scores_from_engine.php", formData, processGameScoreResponse)
  }

function processMoveChoiceResponse(json) {
  //console.log(" process move choice callback",json)
  if (json.hasOwnProperty('error')) {
    openErrorModal(json['programRun'],json['error'])
    return;
  }
  
  const san = treeDisplay.value[0].moves[currentSelectedMoveIndex].move.san
  const colorToMove = (currentSelectedMoveIndex % 2 == 0) ? "White" : "Black"
  const moveNumber = Math.trunc(currentSelectedMoveIndex/2) + 1
  const sentFen = json['fens']

  // already grabbed the move analysis text if done
  moveHash = sentFen

  var moveJsonEntries = []

  //console.log("SENTFEN ",sentFen)
  moveChoiceDisplayArray.value = []
  var pvs = []
  const pvsString = json["fen_pvs0"]
  const moveChoices = (pvsString == "") ? [] : pvsString.split("\t")
  //console.log("moveChoices",moveChoices)
  for (var i=0; i < moveChoices.length; i++) {
    const entry = moveChoices[i].split(",")
    const uciArray = entry[4].split(" ")
    //console.log("entry",entry)
    var onePv = {
      index : i,
      depth : entry[1],
      scoreType : entry[2],
      scoreValue : parseInt(entry[3]),
      scoreDisplay : scoreToString(entry[2],entry[3]),
      bestMoves : ucisToSans(sentFen,entry[4],6),
      uci : uciArray[0],
      selected : false
    }
    //console.log("ONEPV",onePv)
    const bestMoves = onePv.bestMoves.split(" ")
    onePv.bestMove = bestMoves[0]

    // strip the 3 characters so this will compare again the link in the move analysis
    onePv.strippedSan = bestMoves[0].replace(/[=+#]/g, '')
    
    //console.log("onePV",onePv)
    moveChoiceDisplayArray.value.push(onePv)
    var oneMoveJson = {
      score : onePv.scoreDisplay,
      move : onePv.bestMove,
      continuation : ucisToSans(sentFen,entry[4],6)
    }
    moveJsonEntries.push(oneMoveJson)
  }
  const moveJson = {
      fen : sentFen,
      colorToMove : colorToMove,
      moveChoices : moveJsonEntries
    }
  moveJsonString = JSON.stringify(moveJson)
  //console.log("MOVE JSON",moveJsonString)
  timerCanStop = true

  if (doMoveAnalysis)
    moveAnalysis()
}

  function getMoveChoices(fen) {

    calcScoreSeconds = 3 + 1
    timerCanStop = false
    scoringSecondsLeft.value = "Scoring..." + calcScoreSeconds + " secs"
    startScoringTimer()

    var formData = {
      fens : fen,
      key : "blah",
      pv : "12",
      time : "3000"
    }

    //console.log("FORMDATA",formData)
    useGetData("get_scores_from_engine.php", formData, processMoveChoiceResponse)
  }

  function processGameSaveResponse(json) {
    //console.log(" process game save callback",json)
    if (json.hasOwnProperty('error')) {
      openErrorModal(json['programRun'],json['error'])
      return;
    }
    gameHash = json['hash']
    openingName = json['opening_name']
  }

  function saveGame(sans,fens,tagKeys,tagValues) {

    var formData = {
      keys : tagKeys,
      values : tagValues,
      sans : sans,
      fens : fens
    }

    //console.log("FORMDATA",formData)
    useGetData("ai_game_save.php", formData, processGameSaveResponse)
  }

  function processGameLoadResponse(json) {
    //console.log(" process game load callback",json)
    if (json.hasOwnProperty('error')) {
      openErrorModal(json['programRun'],json['error'])
      return;
    }
    const gameSans = json['sans']
    openingName = json['opening_name']
    chess.reset()
    pgnToTreeDisplay(null,gameSans)
  }

  function loadGame(hash) {

    var formData = {
      hash : hash
    }

    //console.log("FORMDATA",formData)
    useGetData("ai_game_load.php", formData, processGameLoadResponse)
  }

</script>

<style scoped>

.item-selected {
  color : yellow;
}

.info-window-dark {
  background-color : rgb(30,30,30);
}
.info-window-light {
  background-color : #e5e5e5;
}

.info-welcome {
  text-align : center;
  font-weight: bold;
  margin-top : 10px;
}

.info-bubble {
  margin : 5px;
  padding : 5px;
  border-radius: 10px;
  border: 1px solid black;
  width: fit-content;
}

.info-other-dark {
  text-align : left;
  font-weight : normal;
  background-color: rgb(59,59,61);
  color : white;
}

.info-me-dark {
  text-align : right;
  background-color: rgb(66,131,247);
  color : white;
  margin-left: auto;
  margin-right: 0;
  font-weight: normal;
}

.info-other-light {
  text-align : left;
  font-weight : normal;
  background-color: rgb(233,233,235);
  color : rgb(36,36,36);
}

.info-still-working-dark {
  background-color: #49494c;
}

.info-still-working-light {
  background-color: #b7b7b7;
}

.info-me-light {
  text-align : right;
  background-color: rgb(54,122,246);
  color : white;
  margin-left: auto;
  margin-right: 0;
  font-weight: normal;
}

.item {
  margin:5px auto;
}

.interesting-move {
  min-width: 100px;
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
}

.invisible-bottom-element {
  visibility : hidden;
  height : 1.2rem;
  margin : 10px;
}

.different-background {
  background-color: blue;
}
</style>
